import React from 'react';
import { color, font } from '../constants';
import ReactLogoPng from '../imnages/logo192.png';
import styled from 'styled-components';

const LogoCont = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none !important;
  color: ${color.sec};
  user-select: none;
  padding: .5rem .7rem;
  border-radius: .5rem;
  flex-grow: 1;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .2),
             -2px -2px 2px rgba(255, 255, 255, .5);
  &:visited{
    color: ${color.sec};
  }
  &:active{
    color: ${color.prim};
    box-shadow: inset 2px 2px 2px rgba(0, 0, 0, .2),
                inset -2px -2px 2px rgba(255, 255, 255, .5);
  }
  @media(min-width: 576px){
    padding: 1rem 1.2rem;
  }
`
const LogoText = styled.p`
  margin: 0;
  text-transform: uppercase;
  font-family: ${font.title};
  border-bottom-style: solid;
  border-bottom-width: 5px;
  border-color: ${color.prim};
  line-height: 1rem;
`
export default ()=> (
  <LogoCont href="#">
    <img alt="react logo" src={ReactLogoPng} width={25} height={25} />
    <LogoText>raos</LogoText>
  </LogoCont>
);
